import { Component, OnInit } from '@angular/core';
import { Song } from 'src/shared/models/song.model';
import { SongService } from 'src/shared/services/song.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public song: Song;
  public initSongTitle: string;
  private bannedTitles: string[] = [];
  public totalSongs: number = 0;

  constructor(
    private songService: SongService
  ) { }

  /////////////////////////
  //// LIFECYCLE HOOKS ////
  /////////////////////////

  ngOnInit() {
    this.song = this.songService.GetForToday();

    this.initSongTitle = this.song.title;

    this.totalSongs = this.songService.CountSongs();
  }

  //////////////////////////
  //// ACTION FUNCTIONS ////
  //////////////////////////

  onClickGetRandomSong() {
    this.song = this._getRandomSong();
  }

  //////////////////////////////////
  //// PRIVATE HELPER FUNCTIONS ////
  //////////////////////////////////

  private _getRandomSong(): Song {
    if (this.song && this.song.title) {
      this.bannedTitles.push(this.song.title);
    }

    let newSong = this.songService.GetRandom(this.bannedTitles);

    if (newSong == null) {
      this.bannedTitles = [ this.song.title ];
    }

    newSong = this.songService.GetRandom(this.bannedTitles);

    return newSong;
  }

}
